import { useAuth } from '@providers/AuthProvider';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MaestroLoader from '@components/MaestroLoader';
import { Stack } from '@mui/joy';
import { maestroLogo } from '@utils/assets';

export default function AppLoading() {
  const /*auth*/ {isLoading, user} = useAuth();
  // const {isLoading, user} = auth;
  const navigate = useNavigate();

  useEffect(() => {
    if(isLoading) {
      return;
    }

    if(user) {
      navigate('/dashboard');
      return;
    }

    navigate('/login');
  }, [isLoading, user]);

  return (
    <Stack alignItems={'center'} justifyContent={'center'} gap={4} height={'100vh'}>
      <img
        src={maestroLogo}
        alt="Maestro Logo"
        style={{width: '300px', minWidth: '100px'}}
      />
      <MaestroLoader/>
    </Stack>
  );
}
